module.exports = __webpack_public_path__ + "assets/img/blindBoxWish.48e5f1e5.png";